import { useQueryWithUserId } from '@northladder/services';

import { BIDS_API } from '../bidsAPIClient';
import { TBidModelsFiltersUrlOptions } from '../types';

/**
 * This is to track the models filter query key in react query cache.
 * TODO: Get a better descriptive name for this key.
 */
export const MODELS_FILTER_KEY = 'models-filter-key';

/**
 * This performs a filter request and retrieves the models filter options and
 * rank report.
 * Provides data fetching states to be used in the models dropdowns and
 * rank report component.
 */
export const useBidsModelsQuery = ({
  categoryId,
  brandId,
}: TBidModelsFiltersUrlOptions) => {
  const {
    isLoading,
    isPending,
    isError,
    error,
    isPaused,
    isFetching,
    data,
    refetch,
  } = useQueryWithUserId({
    queryKey: [MODELS_FILTER_KEY, categoryId, brandId],
    networkMode: 'always', // Even make calls when offline
    retry: 3, // For failed Request, do retry three times.
    enabled: false, // It's a dependant query so don't run immediately.
    queryFn: () => BIDS_API.fetchAllBidModelsFilters({ categoryId, brandId }),
  });

  return {
    data,
    error,
    isLoading,
    isPending,
    isError,
    isPaused,
    isFetching,
    refetch,
  };
};
